import DOMPurify from 'dompurify';

// @ts-ignore
/**
 * Sanitize HTML strings before passing into "dangerouslySetInnerHTML"
 * @param htmlString
 */
var sanitize = function sanitize(htmlString) {
  var allowTargetAttribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (allowTargetAttribute) {
    DOMPurify.setConfig({
      ADD_ATTR: ['target']
    });
    DOMPurify.addHook('afterSanitizeAttributes', node => {
      if (allowTargetAttribute && node.target) {
        // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
        node.setAttribute('rel', 'noopener noreferrer');
      }
    });
  }
  var sanitized = DOMPurify.sanitize(htmlString);
  if (allowTargetAttribute) {
    // Reset config so next call does not contain same settings
    DOMPurify.clearConfig({});
  }
  return {
    __html: sanitized
  };
};

export { sanitize };
